import { setHidden } from './utils'

const observedForms = new WeakSet()

const getAddressForms = (root) =>
	[...root.querySelectorAll('.wc-block-components-address-form')].filter(el => el.id !== 'contact')

const isDisplayNone = (el) => el?.style?.display === 'none'

const getPluginHiddenFields = (form) =>
	[...form.querySelectorAll('[id^="idpc-hide-"]')]

const pluginIsHidingFields = (form) => {
	const hiddenByPlugin = getPluginHiddenFields(form)
	if (hiddenByPlugin.length) return hiddenByPlugin.some(isDisplayNone)

	const sentinel = form.querySelector(
		'.wc-block-components-address-form__city, .wc-block-components-address-form__postcode, .wc-block-components-address-form__address_1'
	)
	return isDisplayNone(sentinel)
}

const pluginHasRevealedFields = (form) => {
	const hiddenByPlugin = getPluginHiddenFields(form)
	return hiddenByPlugin.length > 0 && !hiddenByPlugin.some(isDisplayNone)
}

const getFormStep = (form) =>
	form.closest('.wc-block-components-checkout-step') || form.parentElement || form

const removeManualEntryLink = (form) => {
	getFormStep(form)
		.querySelectorAll('.idpc-manual-entry-link')
		.forEach(el => el.remove())
}

const syncAddressFieldUi = (form) => {
	const shouldHide = pluginIsHidingFields(form)
	const toggle = form.querySelector('.wc-block-components-address-form__address_2-toggle')
	if (toggle && isDisplayNone(toggle) !== shouldHide) {
		setHidden(toggle, shouldHide)
	}

	if (pluginHasRevealedFields(form)) removeManualEntryLink(form)
}

const observeForm = (form) => {
	if (observedForms.has(form)) return
	observedForms.add(form)

	const observer = new MutationObserver(() => syncAddressFieldUi(form))
	observer.observe(getFormStep(form), {
		subtree: true,
		childList: true,
		attributes: true,
		attributeFilter: ['style', 'id'],
	})
}

export const enhanceHideAddressField = (root) => {
	getAddressForms(root).map(form => {
		observeForm(form)
		syncAddressFieldUi(form)
	})
}
